import {
  UseInfiniteQueryOptions,
  useInfiniteQuery,
  useQueryClient,
} from 'react-query';
import { REQUEST_MEMBER_LIST } from '../constant/QueryKeyName';
import { getListUserRequestJoinGroup } from '../apis/tms/folder.api';
import { useEffect } from 'react';

export const useJoinGroupRequest = (
  folderId: string,
  opt: Omit<
    UseInfiniteQueryOptions<any, Error, any, any, string[]>,
    'queryKey' | 'queryFn'
  >,
  isUseStateToManageData?: boolean
) => {
  const queryClient = useQueryClient();

  const refetchNotAffectState = () =>
    queryClient.refetchQueries([REQUEST_MEMBER_LIST, folderId, '0']);

  const refetchAffectState = () =>
    queryClient.refetchQueries([REQUEST_MEMBER_LIST, folderId, '1']);

  const query = useInfiniteQuery(
    [REQUEST_MEMBER_LIST, folderId, isUseStateToManageData ? '1' : '0'],
    getListUserRequestJoinGroup,
    {
      ...opt,
      getNextPageParam: (_lastPage: any, _allPages: any[]) => {
        return _lastPage?.hasNextPage ? _lastPage?.currentPage + 1 : undefined;
      },
      refetchOnMount: true,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (isUseStateToManageData && query.isFetching) {
      queryClient.refetchQueries([REQUEST_MEMBER_LIST, folderId, '0']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUseStateToManageData, query.isFetching]);

  return {
    query,
    refetchNotAffectState,
    refetchAffectState,
  };
};
